<template>
  <div 
    id="spinner-container"
    v-if="isLoading && !forceHideLoader"
  >
    <v-progress-circular 
      id="progress-spinner"
      v-if="isLoading && !forceHideLoader"
      indeterminate 
      size="100"
      width="10"
      units="px"
    />
  </div>
</template>

<script>
export default {
  name: "ProgressSpinner",
  props: {
    isLoading: Number,
    forceHideLoader: Boolean
  }
}
</script>

<style scoped>
#progress-spinner {
  width: 100%;
  margin: auto;
  position: absolute;
  z-index: 1005;
}

#spinner-container {
  width: 100vw;
  height: 100vh;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>